export default __webpack_public_path__ + "static/logo-04c3877fd5329900be245bc44140cae1.svg";